import axios from "axios";

const api = axios.create({
    baseURL: "https://backend.aniverse.pro",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    }
})

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("Token");
    const userId = localStorage.getItem("User-Id");
    if (token && userId) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["User-Id"] = userId;
    }

    return config;
});

export default api;